import "./firstvisit.scss";
import { Link } from "react-router-dom";

// First-visit guide (backlog #6, 2026-10-24): homepage visitors who had
// never taken a class had no answer to "what do I wear / bring / do?"
// before booking, which is a common reason to leave without signing up.
// General information only — comfortable clothes, a water bottle, what a
// beginner class is like, and arriving a few minutes early. No new
// benefit, price, schedule, or policy is claimed here; "no experience
// needed / train at your own pace" restates the Programs section, and
// the only contact details are the existing phone number and trial anchor.
export default function FirstVisit() {
  return (
    <section className="section first-visit-section" id="first-visit">
      <div className="container first-visit-container">
        <p className="first-visit-eyebrow">FIRST VISIT GUIDE</p>
        <h2 className="first-visit-title">New Here? Here&apos;s What to Expect</h2>
        <p className="first-visit-lead">
          Your first class is a trial — no experience needed. A few simple
          tips so you, or your child, can walk in feeling ready.
        </p>

        <div className="grid first-visit-grid">
          <div className="first-visit-card">
            <div className="first-visit-icon" aria-hidden="true">
              👕
            </div>
            <h3>What to Wear</h3>
            <p>
              Comfortable clothes you can move, stretch and kick in — like a
              T-shirt and athletic pants or shorts. Classes train barefoot
              on the mat, so there are no special shoes to buy.
            </p>
          </div>

          <div className="first-visit-card">
            <div className="first-visit-icon" aria-hidden="true">
              🎒
            </div>
            <h3>What to Bring</h3>
            <p>
              Just a water bottle and yourself. No uniform or gear is needed
              for a trial class — just come ready to move.
            </p>
          </div>

          <div className="first-visit-card">
            <div className="first-visit-icon" aria-hidden="true">
              🥋
            </div>
            <h3>What Happens in Class</h3>
            <p>
              You&apos;ll check in, meet the instructor, warm up, and learn
              basic movements step by step. The instructor guides beginners
              through everything.
            </p>
          </div>

          <div className="first-visit-card">
            <div className="first-visit-icon" aria-hidden="true">
              ⏰
            </div>
            <h3>When to Arrive</h3>
            <p>
              Arriving a few minutes early gives you time to check in and
              meet the instructor before class starts. Most students begin
              as complete beginners, and you train at your own pace.
            </p>
          </div>
        </div>

        <p className="first-visit-cta-row">
          <Link to="/#trial" className="first-visit-cta">
            Ready? Book My FREE Class
          </Link>
        </p>
        <p className="first-visit-alt">
          Questions? <a href="mailto:pskyman1@gmail.com">Email us at pskyman1@gmail.com</a>
        </p>
      </div>
    </section>
  );
}
